
export const SHOW_SKIP_INTRO_EVENT = 'show_skip_intro_button_event';
export const SEEK_VOD_PLAYER_CONTROLS_EVENT = 'seek_vod_player_controls_event';
export const RESET_AUTOHIDE_VOD_PLAYER_CONTROLS_EVENT = 'reset_autohide_vod_player_controls_event';
// export const SHOW_PLAYER_CONTROLS_EVENT = 'show_player_controls_event';

export const PlayerControlsActivity = (eventName, data) => ({
    eventName, 
    data
});
export class PlayerControlsActivityNotifier {
    constructor() {
        this.subscribers = [];
    }

    subscribe(suscriber) {
        this.subscribers.push(suscriber);
    }

    sendActivity(playerControlsActivity) {
        this.subscribers.forEach(subscriber => {
            subscriber.notifyActivity && subscriber.notifyActivity(playerControlsActivity);
        });
    }
}


// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsActivity.js